import React from 'react'
import Chart from "chart.js/auto";
import { Line } from "react-chartjs-2";
import { CategoryScale } from "chart.js";
Chart.register(CategoryScale);


export const LineChart = ({ scaleX, scaleY, plotData, interval, chartLabel, indicator }) => {
  
const labels = interval || ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const data = {
  labels: labels,
  datasets: [
    {
      label: chartLabel || "Line Chart",
      backgroundColor: indicator || "rgb(255, 99, 132)",
      lineTension: 0.5,
      borderColor: indicator || "#ff8600",
      fill: false,
      borderWidth: 3,
      data: plotData || [0, 10, 5, 2, 20, 30, 45, 20, 30],
    },
  ],
};
// const options = {
//   type: "line",
//   data: data,
// };

  return (
    <Line
      data={data}
      options={{
        title: {
          display: true,
          text: "Average Rainfall per month",
          fontSize: 20,

          // scales: { xAxes: [{}], yAxes: [{}] },
          // elements: { line: { fill: false } },
          // fill: false
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: "right",
        },
        scales: {
          x: scaleX,

          y: scaleY,
        },
      }}
    />
  );
}
